import React from 'react';

const dictationData = [
  {
    activity: 'Dicta Drill',
    description: '-',
    options: '-',
  },
  {
    activity: 'Dictation Test',
    description: '-',
    options: '-',
  },
  {
    activity: 'Dictation Notes',
    description: '-',
    options: '-',
  },
  {
    activity: 'Listen-Write on Paper',
    description: 'Listen to an audio clip and write the content down on paper.',
    options: [
      'Select Language', 'Select Voice Pitch', 'Voice Rate', 'Voice Volume', 
      'Pause between Words', 'Repeat', 'View Practice History', 'Share', 
      'View Drill Log', 'Add Observers', 'Add Collaborators'
    ],
  },
  {
    activity: 'Listen-Write on Screen',
    description: 'Listen to an audio clip and type the content into a digital document or text field.',
    options: [
      'Select Language', 'Select Voice Pitch', 'Voice Rate', 'Voice Volume', 
      'Pause between Words', 'Repeat', 'View Practice History', 'Share', 
      'View Drill Log', 'Add Observers', 'Add Collaborators'
    ],
  },
  {
    activity: 'Listen-Input',
    description: 'Listen to an audio clip and use speech-to-text technology to input the content directly into a digital form.',
    options: [
      'Select Language', 'Select Voice Pitch', 'Voice Rate', 'Voice Volume', 
      'Pause between Words', 'Repeat', 'View Practice History', 'Share', 
      'View Drill Log', 'Add Observers', 'Add Collaborators'
    ],
  },
  {
    activity: 'View-Listen-Write',
    description: 'View a video or multimedia presentation, listen to the audio, and write down key points or notes.',
    options: [
      'Select Language', 'Select Voice Pitch', 'Voice Rate', 'Voice Volume', 
      'Pause between Words', 'Repeat', 'View Practice History', 'Share', 
      'View Drill Log', 'Add Observers', 'Add Collaborators'
    ],
  },
  {
    activity: 'Write from Memory-Paper',
    description: 'Recall information from memory and write it down on paper without any external aids.',
    options: [
      'Select Language', 'Select Voice Pitch', 'Voice Rate', 'Voice Volume', 
      'Pause between Words', 'Repeat', 'View Practice History', 'Share', 
      'View Drill Log', 'Add Observers', 'Add Collaborators'
    ],
  },
  {
    activity: 'Write from Memory on Screen',
    description: 'Recall information from memory and type it into a digital document or text field without any external aids.',
    options: [
      'Select Language', 'Select Voice Pitch', 'Voice Rate', 'Voice Volume', 
      'Pause between Words', 'Repeat', 'View Practice History', 'Share', 
      'View Drill Log', 'Add Observers', 'Add Collaborators'
    ],
  },
  {
    activity: 'Write from Memory-Input',
    description: 'Recall information from memory and use speech-to-text technology to input it directly into a digital form.',
    options: [
      'Select Language', 'Select Voice Pitch', 'Voice Rate', 'Voice Volume', 
      'Pause between Words', 'Repeat', 'View Practice History', 'Share', 
      'View Drill Log', 'Add Observers', 'Add Collaborators'
    ],
  },
  {
    activity: 'Create Your Own Drill',
    description: 'Create customized dictation drills.',
    options: ['Share Free', 'Monetize'],
  },
  {
    activity: 'Additional Information',
    description: 'Please refer to the platform documentation for more details on customization options and best practices.',
    options: 'For further assistance, contact support or visit our help center.',
  },
];

const DictaFeatures = () => (
  <div className="min-h-screen bg-gray-100 py-10 px-4 flex flex-col items-center justify-center">
    <h2 className="text-3xl font-bold text-blue-600 mb-6 text-center">
      DictaBook@Think5Whys Features
    </h2>
    <div className="max-w-7xl w-full shadow-lg rounded-lg overflow-hidden bg-white">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-blue-600">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-semibold text-white uppercase tracking-wider">Activity</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-white uppercase tracking-wider">Description</th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-white uppercase tracking-wider">Options</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {dictationData.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                <td className="px-6 py-4 text-sm font-medium text-gray-900 break-words">{item.activity}</td>
                <td className="px-6 py-4 text-sm text-gray-600 break-words">{item.description}</td>
                <td className="px-6 py-4 text-sm text-gray-600 break-words">
                  {Array.isArray(item.options) ? item.options.join(', ') : item.options}
                </td>
              </tr>
            ))}
            <tr>
              <td colSpan="3" className="px-6 py-4 text-center text-sm font-semibold text-blue-600 bg-gray-100 break-words">
                {dictationData[dictationData.length - 1].description}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default DictaFeatures;

